import { Grid, Collapse } from '@material-ui/core';

import styled from 'styled-components';

import { mediaQueries } from '../../../../libs';

export const StyledHeader = styled.header`
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 10;
  top: 0;
  display: flex;
  flex-wrap: wrap;
  direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const FullContainer = styled(Grid)`
  background: ${({ background, theme }) => background || theme.colors.header};
  max-width: ${({ maxwidth }) => maxwidth};
  min-height: 30px;
  justify-content: center !important;
  ${({ theme, mobile }) =>
    mobile
      ? ''
      : `@media (max-width: ${theme.breakpoints.md.material}px) {
          display: none !important
        }`}
`;

export const Container = styled(Grid)`
  width: 100%;
  max-width: ${mediaQueries.default}px !important;
`;

export const CollapseStyled = styled(Collapse)`
  width: 100% !important;
`;
